const formatNumber = (number: number) => {
    // return new Intl.NumberFormat("pt-BR").format(number);
    return number.toLocaleString("pt-br", { minimumFractionDigits: 0 });
};

export default formatNumber;
